// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3my-p","error":"Textarea_error__2FMKn","readonly":"Textarea_readonly__21kT1","disabled":"Textarea_disabled__3jBoR"};